import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SicotService } from '../sicot.service';
import { CotAdminUser } from '../types/CotAdminUser';
import { Cot } from '../types/Cot';
import { Wso2Group } from '../types/Wso2Group';
import { TipoSegnalazioneAdmin } from '../types/TipoSegnalazioneAdmin';
import { CommonModule } from '@angular/common';

export interface DettaglioUtenteWso2DialogData {
  user: CotAdminUser;
}

@Component({
  selector: 'app-dettaglio-utente-wso2-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './dettaglio-utente-wso2-dialog.component.html',
  styleUrl: './dettaglio-utente-wso2-dialog.component.css',
})
export class DettaglioUtenteWso2DialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<DettaglioUtenteWso2DialogComponent>);
  private readonly data = inject<DettaglioUtenteWso2DialogData>(MAT_DIALOG_DATA);
  private readonly sicot = inject(SicotService);

  user: CotAdminUser = this.data.user;
  groups: Wso2Group[] = [];
  cots: Cot[] = [];
  tipiSegnalazione: TipoSegnalazioneAdmin[] = [];
  loadingGroups = true;
  loadingCots = true;
  loadingTipiSegnalazione = true;
  errorGroups: string | null = null;
  errorCots: string | null = null;
  errorTipiSegnalazione: string | null = null;

  ngOnInit(): void {
    this.loadGroups();
    this.loadCots();
    this.loadTipiSegnalazione();
  }

  loadGroups(): void {
    this.loadingGroups = true;
    this.errorGroups = null;
    this.sicot.getUsersGroups(this.user.id).subscribe({
      next: (list) => {
        this.groups = list ?? [];
        this.loadingGroups = false;
      },
      error: () => {
        this.errorGroups = 'Errore nel caricamento dei gruppi';
        this.loadingGroups = false;
      },
    });
  }

  loadCots(): void {
    this.loadingCots = true;
    this.errorCots = null;
    this.sicot.getUserCots(this.user.id).subscribe({
      next: (list) => {
        this.cots = list ?? [];
        this.loadingCots = false;
      },
      error: () => {
        this.errorCots = 'Errore nel caricamento delle COT';
        this.loadingCots = false;
      },
    });
  }

  loadTipiSegnalazione(): void {
    this.loadingTipiSegnalazione = true;
    this.errorTipiSegnalazione = null;
    this.sicot.getUserTipiSegnalazione(this.user.id).subscribe({
      next: (list) => {
        this.tipiSegnalazione = list ?? [];
        this.loadingTipiSegnalazione = false;
      },
      error: () => {
        this.errorTipiSegnalazione = 'Errore nel caricamento dei tipi segnalazione';
        this.loadingTipiSegnalazione = false;
      },
    });
  }

  chiudi(): void {
    this.dialogRef.close();
  }
}
